// @import dependencies
// @end

// @import event types
import { AuthActionTypes, IAppState, SCREEN_MODE, EXPAND, SIDEBAR_MENU_SELECTED, SIDEBAR_COMPONENT, CHATBOT_CHANGE, HELPSTEPS_CHANGE, SHOPPING_CAR_CHANGE } from './types';
// @end

const initialState: IAppState = {
  chatbot: {
    open: false,
    page: null,
    metadata: null
  },
  helpSteps: {
    open: false
  },
  sidebar: {
    collapse: false,
    selected: 'menu-home',
  },
  screenMode: 'light',
  sidebarComponent: {
    component: null,
    status: 'disabled'
  },
  shoppingCart: {action: 'none', data: []}
}

export function appReducer(
  state = initialState,
  action: AuthActionTypes,
): IAppState {
  switch (action.type) {
    case HELPSTEPS_CHANGE: {
      return {
        ...state,
        helpSteps: action.payload
      }
    }
    case CHATBOT_CHANGE: {
      return {
        ...state,
        chatbot: action.payload
      }
    }
    case EXPAND:
      return {
        ...state,

        sidebar: {
          ...state.sidebar,
          collapse: action.payload,
        },
      }
    case SIDEBAR_COMPONENT: {
      return {
        ...state,
        sidebarComponent: action.payload
      }
    }
    case SIDEBAR_MENU_SELECTED: {
      return {
        ...state,

        sidebar: {
          ...state.sidebar,
          selected: action.payload,
        },
      }
    }
    case SCREEN_MODE: {
      return {
        ...state,
        screenMode: action.payload,
      }
    }
    case SHOPPING_CAR_CHANGE: {
      localStorage.setItem("shoppingCart", JSON.stringify(action.payload)); // Guardar en localStorage
      return {
        ...state,
        shoppingCart: action.payload,
      }
    }
    default:
      return state
  }
}
